import React from 'react';
import VerifyOtp from '../section/loginpage/VerifyOtp';

export default function VerifyOtpPage() {
  return (
    <div>
      <VerifyOtp />
    </div>
  );
}
